import { ReactSVG } from 'react-svg';

import Icon from '../button/enums/Icon';

import './IconRender.scss';

const IconColorMapping = {
  [Icon.alcohol]: ['fill'],
  [Icon.beweging]: ['fill'],
  [Icon.bloeddruk]: ['fill'],
  [Icon.arrowLeft]: ['fill'],
  [Icon.arrowRight]: ['fill'],
  [Icon.chevronRight]: ['fill'],
  [Icon.chevron]: ['fill'],
  [Icon.gewicht]: ['fill'],
  [Icon.koffie]: ['fill'],
  [Icon.roken]: ['fill'],
  [Icon.slapen]: ['fill'],
  [Icon.stress]: ['fill'],
  [Icon.vitalewaarden]: ['fill'],
  [Icon.voeding]: ['fill'],
  [Icon.renew]: ['fill'],
  [Icon.email]: ['fill'],
  [Icon.suggestion]: ['fill'],
  [Icon.cholesterol]: ['fill'],
  [Icon.file]: ['fill'],
  [Icon.doel]: ['fill'],
  [Icon.settings]: ['fill'],
  [Icon.succes]: ['fill'],
  [Icon.wegwijzer]: ['fill'],
  [Icon.alert]: ['fill'],
  [Icon.checkboxRound]: ['fill'],
};

type PropType = {
  icon: Icon;
  color?: string;
  width?: string;
  height?: string;
  className?: string;
};

const IconRender = ({ icon, color = 'var(--black)', width = '20px', height = '20px', className = '' }: PropType) => {
  // Set the width, height and color of the SVG.
  const handleSvgBeforeInjection = (svg: SVGElement) => {
    svg.setAttribute('width', width || '0');
    svg.setAttribute('height', height || '0');

    if (color && IconColorMapping[icon]) {
      const paths = svg.querySelectorAll('path');
      if (paths) {
        Array.from(paths).forEach((path) => {
          IconColorMapping[icon].forEach((attribute) => {
            path.setAttribute(attribute, color);
          });
        });
      }
    }
  };

  return (
    <ReactSVG
      src={`/images/icons/${icon}.svg`}
      wrapper="span"
      className={`${className} icon`}
      beforeInjection={handleSvgBeforeInjection}
      style={{
        width,
        height,
      }}
    />
  );
};

export default IconRender;
